import React from 'react';
import {Row, Col, Icon, message} from 'antd';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';

@inject('homeStore')
@observer
class App extends React.Component {
  mouseOver() {
    typeof this.props.onMouseOver === 'function' && this.props.onMouseOver()
  }
  mouseOut() {
    typeof this.props.onMouseOut === 'function' && this.props.onMouseOut()
  }
  render() {
    const {showSubTitle = 0} = this.props;
    const {homeStore} = this.props;
    let {subNavigation, navPage} = homeStore;
    subNavigation = toJS(subNavigation);
    let maxLen = 15;
    let maxCircle = Math.ceil(subNavigation.length / maxLen);
    let maxPage = Math.ceil(maxCircle / 6);
    let start = (navPage - 1) * 6, end = navPage * 6;
    let subNavigationTemp = [];
    for (let i = start; i < maxCircle && i < end; i++) {
      subNavigationTemp.push(
        (
          <Col key={'max' + i}
               span={4}
               className={`home-page-subnavigation ${showSubTitle !== 0 && 'showSubTitle'}`}
               onMouseOver={this.mouseOver.bind(this)}
               onMouseOut={this.mouseOut.bind(this)}>
            {subNavigation.slice(i * maxLen, i * maxLen + maxLen)}
          </Col>
        )
      );
    }
    return (
      <div>
        {
          maxPage > 1 && (
            <Col span={1} key={'prePage'}
                 className={`home-page-subnavigation home-page-turn-page ${showSubTitle !== 0 && 'showSubTitle'}`}
                 onMouseOver={this.mouseOver.bind(this)}
                 onMouseOut={this.mouseOut.bind(this)}>
              <Icon type="left" onClick={() => {
                if (navPage === 1) {
                  message.info('当前为第一页');
                }
                else {
                  homeStore.navPage -= 1;
                }
              }}/>
            </Col>
          )
        }
        <Col span={17}
             key={'currentPage'}
             className={maxPage > 1 ? 'current-page' : ''}
             onMouseOver={() => {
               if (maxPage > 1) this.mouseOver()
             }}
             onMouseOut={() => {
               if (maxPage > 1) this.mouseOut()
             }}>
          <Row>
            {subNavigationTemp}
          </Row>
        </Col>
        {
          maxPage > 1 && (
            <Col span={1} key={'nextPage'}
                 className={`home-page-subnavigation home-page-turn-page ${showSubTitle !== 0 && 'showSubTitle'}`}
                 onMouseOver={this.mouseOver.bind(this)}
                 onMouseOut={this.mouseOut.bind(this)}>
              <Icon type="right" onClick={() => {
                if (navPage === maxPage) {
                  message.info('当前为最后一页');
                }
                else {
                  homeStore.navPage += 1;
                }
              }}/>
            </Col>
          )
        }
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/home/navigation/NavRight.js